var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1942_40987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2H13.5V1.25C13.5 1.05109 13.421 0.860322 13.2803 0.71967C13.1397 0.579018 12.9489 0.5 12.75 0.5C12.5511 0.5 12.3603 0.579018 12.2197 0.71967C12.079 0.860322 12 1.05109 12 1.25V2H6V1.25C6 1.05109 5.92098 0.860322 5.78033 0.71967C5.63968 0.579018 5.44891 0.5 5.25 0.5C5.05109 0.5 4.86032 0.579018 4.71967 0.71967C4.57902 0.860322 4.5 1.05109 4.5 1.25V2H3.75C2.7558 2.00119 1.80267 2.39666 1.09966 3.09966C0.396661 3.80267 0.00119089 4.7558 0 5.75L0 14.75C0.00119089 15.7442 0.396661 16.6973 1.09966 17.4003C1.80267 18.1033 2.7558 18.4988 3.75 18.5H14.25C15.2442 18.4988 16.1973 18.1033 16.9003 17.4003C17.6033 16.6973 17.9988 15.7442 18 14.75V5.75C17.9988 4.7558 17.6033 3.80267 16.9003 3.09966C16.1973 2.39666 15.2442 2.00119 14.25 2ZM1.5 5.75C1.5 5.15326 1.73705 4.58097 2.15901 4.15901C2.58097 3.73705 3.15326 3.5 3.75 3.5H14.25C14.8467 3.5 15.419 3.73705 15.841 4.15901C16.2629 4.58097 16.5 5.15326 16.5 5.75V6.5H1.5V5.75ZM14.25 17H3.75C3.15326 17 2.58097 16.7629 2.15901 16.341C1.73705 15.919 1.5 15.3467 1.5 14.75V8H16.5V14.75C16.5 15.3467 16.2629 15.919 15.841 16.341C15.419 16.7629 14.8467 17 14.25 17Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.875C9.62132 12.875 10.125 12.3713 10.125 11.75C10.125 11.1287 9.62132 10.625 9 10.625C8.37868 10.625 7.875 11.1287 7.875 11.75C7.875 12.3713 8.37868 12.875 9 12.875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.875C5.87132 12.875 6.375 12.3713 6.375 11.75C6.375 11.1287 5.87132 10.625 5.25 10.625C4.62868 10.625 4.125 11.1287 4.125 11.75C4.125 12.3713 4.62868 12.875 5.25 12.875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.875C13.3713 12.875 13.875 12.3713 13.875 11.75C13.875 11.1287 13.3713 10.625 12.75 10.625C12.1287 10.625 11.625 11.1287 11.625 11.75C11.625 12.3713 12.1287 12.875 12.75 12.875Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1942_40987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1f74ae8fb654acd891e01954e7063e3c.svg";
export { ForwardRef as ReactComponent };